
import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { MapPin, Eye, RefreshCw } from 'lucide-react';
import { MapboxTokenInput } from './map/MapboxTokenInput';
import { MapContainer } from './map/MapContainer';
import type { LoginLocation } from './map/MapMarkers';
import { toast } from 'sonner';

interface LocationMapProps {
  locations: LoginLocation[];
}

export const LocationMap = ({ locations }: LocationMapProps) => {
  const [mapboxToken, setMapboxToken] = useState(() => {
    return localStorage.getItem('mapbox_access_token') || '';
  });
  const [showTokenInput, setShowTokenInput] = useState(() => {
    return !localStorage.getItem('mapbox_access_token');
  });
  const [markers, setMarkers] = useState<mapboxgl.Marker[]>([]);
  const [loading, setLoading] = useState(false);
  
  useEffect(() => {
    if (locations.length === 0) {
      toast.info('لا توجد مواقع لعرضها على الخريطة، سجّل دخول موظفين للعرض');
    }
  }, [locations]);

  const handleTokenSubmit = () => {
    if (mapboxToken.trim()) {
      setShowTokenInput(false);
    }
  };

  const handleMarkersUpdate = (newMarkers: mapboxgl.Marker[]) => {
    setMarkers(newMarkers);
  };

  if (showTokenInput) {
    return (
      <MapboxTokenInput
        token={mapboxToken}
        onTokenChange={setMapboxToken}
        onSubmit={handleTokenSubmit}
      />
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <MapPin className="w-5 h-5" />
            خريطة مواقع تسجيل الدخول
          </div>
          <div className="flex gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() => setShowTokenInput(true)}
            >
              <Eye className="w-4 h-4 ml-1" />
              تغيير المفتاح
            </Button>
            <Button
              variant="secondary"
              size="sm"
              onClick={() => window.location.reload()}
              disabled={loading}
            >
              <RefreshCw className={`w-4 h-4 ml-1 ${loading ? 'animate-spin' : ''}`} />
              تحديث
            </Button>
          </div>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <MapContainer 
          token={mapboxToken}
          locations={locations}
          onMarkersUpdate={handleMarkersUpdate}
        />
        <div className="mt-4 text-sm text-gray-600">
          {locations.length > 0 ? (
            <p className="flex items-center gap-2">
              <div className="w-4 h-4 bg-blue-600 rounded-full"></div>
              دبوس يمثل موقع تسجيل دخول الموظف - انقر للحصول على التفاصيل ({locations.length} موقع)
            </p>
          ) : (
            <p className="text-center text-gray-500 my-2">
              لا توجد سجلات موقع لعرضها. قم بتسجيل الدخول إلى النظام لإضافة سجلات جديدة.
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
